import React from 'react'
import PropTypes from 'prop-types'
import { useOutletContext, useParams } from 'react-router'
import useTitles from 'common/hooks/useTitles'
import useFetch from 'common/hooks/useFetch'
import ApplicationConf from 'conf/ApplicationConf'
import LotsView from './lots/LotsView'

// Écran lots (ou idées) d'un client
const CustomerLotsApp = ({ ideas = false }) => {
    const { id } = useParams()
    const { customer } = useOutletContext()

    useTitles(() => [{
        label: 'Clients', href: '/customer',
    }, {
        label: customer?.name ?? 'Inconnu', href: `/customer/${id}`,
    }, ideas ? {
        label: 'Idées', href: `/customer/${id}/ideas`,
    } : {
        label: 'Lots', href: `/customer/${id}/lots`,
    }], [id, customer, ideas])

    const { data: lots = [], reload } = useFetch(customer ? ApplicationConf.gdl.lots(id) : undefined)
    const { data: allTickets = [] } = useFetch(ApplicationConf.support.statisticsCreated(), { method: 'POST', body: {} })

    return (
        <LotsView
            lots={lots}
            ideas={ideas}
            reload={reload}
            allTickets={allTickets}
            newClientId={Number(id)}
            customer={customer}
            emptyLabel={ideas ? 'Aucune idée pour ce client.' : 'Aucun lot pour ce client.'}
            defaultView='cards'
            viewStorageKey='aquaparc-lots-view-customer'
            filterStorageKey={ideas ? 'aquaparc-ideas-filter-customer' : 'aquaparc-lots-filter-customer'}
        />
    )
}

CustomerLotsApp.propTypes = {
    ideas: PropTypes.bool,
}

export default CustomerLotsApp
